import React, { Fragment, useState, useEffect } from "react"
import Modal from '@material-ui/core/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Divider from '@material-ui/core/Divider'


function AlergiesListToShow({ id_historia, openModaAlergie = false, handlerOpenModalAlergies }) {
    const [patientAlergies, setPatientAlergies] = useState([]);
    const [loadedPatientAlergies, setLoadedPatientAlergies] = useState(false);

    useEffect(() => {
        const getPatientAlergies = async () => {
            setLoadedPatientAlergies(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/listar?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Error consultando las alergias del paciente");
                }
            }).then((data) => {
                if (data.length > 0) {
                    console.log("Alergias", data)
                    setPatientAlergies(data);
                }
                setLoadedPatientAlergies(false);
            }).catch(err => {
                console.log(err);
                setLoadedPatientAlergies(false);
            });
        }
        getPatientAlergies();
    }, [])

    const etapaToLetters = (etapa) => {
        let etapaName = '';
        switch (etapa) {
            case 1:
                etapaName = 'Niño';
                break;
            case 2:
                etapaName = 'Adulto';
                break;
            case 3:
                etapaName = 'Desconocido';
                break;

            default:
                etapaName = '';
                break;
        }
        return etapaName
    }

    const serverityToLetters = (numSeverity) => {
        let severityName = '';
        switch (numSeverity) {
            case 1:
                severityName = 'Muy leve';
                break;
            case 2:
                severityName = 'Leve';
                break;
            case 3:
                severityName = 'Moderado';
                break;
            case 4:
                severityName = 'Severo';
                break;

            default:
                severityName = '';
                break;
        }
        return severityName
    }
    return (
        <Fragment>
            <Modal
                open={openModaAlergie}
                onClose={() => {
                    handlerOpenModalAlergies(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                    <h5 className="title-alergies"><b>ALERGIAS</b></h5>
                    <hr className="divider-alergies" />
                    {loadedPatientAlergies ?
                        <div className="text-center">
                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                        </div>
                        : patientAlergies.length > 0 ?
                            <div className='group-cards-alergie'>
                                {patientAlergies.map((alergie) => (
                                    <div className='card-show-alergie' key={alergie.id_alergia}>
                                        <div className='content'>
                                            <div><h5><b>{alergie.nombre.toUpperCase()}</b></h5></div>
                                            {alergie.severidad !== null && alergie.severidad !== 0 ? <div><p><b>Severidad: </b>{serverityToLetters(alergie.severidad)}</p></div> : null}
                                            {alergie.etapa !== null && alergie.etapa !== 0 ? <div><p><b>Desde (Etapa): </b>{etapaToLetters(alergie.etapa)}</p></div> : null}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className="info-empty-profile">
                                <h5>El paciente no tiene registrada ninguna alergia en el sistema</h5>
                            </div>
                    }
                </div>
            </Modal>
        </Fragment>
    )
}

export default AlergiesListToShow